import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getLang } from '@app/i18n';

export default function DocumentHead() {
  const { t } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = getLang();
    document.title = t('meta_title');
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', t('meta_description'));
  }, [t]);

  return null;
}
